import { IndicatorsDto } from "./indicators.model";

export class ContentScore {
    score: number;
    reasons: string[];
    link: string;
    text: string;
    type: string;
    indicators: IndicatorsDto;

    constructor(
        score: number = 0,
        reasons: string[] = [],
        link: string = '',
        text: string = '',
        type: string = '',
        indicators: IndicatorsDto = new IndicatorsDto()
    ) {
        this.score = score;
        this.reasons = reasons;
        this.link = link;
        this.text = text;
        this.type = type;
        this.indicators = indicators;
    }
}